import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { processingUuidSelector } from '../../store/selectors/billing.selectors';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../store/state/app.state';

export interface SupportMessageBodyInterface {
  reason: string;
  user_name: string;
  message?: string;
  response_mail: string;
  event_id?: string;
  source?: string; // ['email', 'land']
}

@Injectable({
  providedIn: 'any',
})
export class SupportService {
  private uuid: string = '';

  constructor(private api: ApiService, private store: Store<AppStateInterface>) {
    this.store.select(processingUuidSelector).subscribe((uuid) => {
      this.uuid = uuid;
    });
  }

  sendSupportMessage(body: SupportMessageBodyInterface) {
    let headers: any = {};
    if (this.uuid) {
      headers.Authorization = this.uuid;
    }
    return this.api.post(
      '/api/user/support',
      {
        ...body,
      },
      headers,
    );
  }
}
